import type { BatchData } from '../types';
import MetaField, { MetaTextarea } from './MetaField';

interface Props {
  data: BatchData;
  onPatch: (patch: Partial<BatchData>) => void;
  onFocusField: (fieldId: string | null) => void;
}

export default function ObservationsCard({ data, onPatch, onFocusField }: Props) {
  return (
    <div className="card">
      <div className="card-header">
        <span className="card-title">Observations</span>
      </div>
      <div className="card-body">
        <div className="field-grid fg-3">
          <MetaField label="Appearance" id="metaAppearance" placeholder="e.g. Clear, slightly pearlescent" data={data} onPatch={onPatch} onFocusField={onFocusField} />
          <MetaField label="Scent" id="metaScent" placeholder="e.g. Light floral, fades quickly" data={data} onPatch={onPatch} onFocusField={onFocusField} />
          <MetaField label="Skin feel" id="metaSkinFeel" placeholder="e.g. Non-greasy, absorbs in ~30s" data={data} onPatch={onPatch} onFocusField={onFocusField} />
          <MetaTextarea label="Process notes" id="batchNotes" placeholder="What happened during mixing? Any issues?" data={data} onPatch={onPatch} onFocusField={onFocusField} className="span2" />
          <MetaTextarea label="Next steps" id="batchQC" placeholder="What to test, adjust, or improve?" data={data} onPatch={onPatch} onFocusField={onFocusField} />
        </div>
      </div>
    </div>
  );
}
